import {
  LIKE_TOGGLE,
  RESET_LIKES_ACTION,
  RESET_LIKES,
  MERGE_POST_SOURCE
} from '../actions/likesQueries'
import { userDB } from '../../firestoreDB'
import { RegisterEvent } from '../../analytics'
import firebase from 'firebase'
import { MERGE_POST } from '../actions/postQueries'
import { MERGE_AUTHOR } from '../actions/authorQueries'
import { MERGE_LIKE } from '../actions/favQueries'
import { MERGE_SINGLE_POST } from '../actions/singlePostQueries'

const actions = {
  [LIKE_TOGGLE]: ({dispatch, getters}, {keyPost, score, like, screenName}) => {
    return new Promise((resolve) => {
      const newLike = !like
      const likeData = {
        like: newLike,
        like_date: newLike ? firebase.firestore.Timestamp.fromDate(new Date()) : null,
        like_at: newLike ? score : null
      }
      userDB
        .doc(getters.firebaseUUID())
        .collection('publications')
        .doc(keyPost)
        .update(likeData)
        .then(_ => {
          // dispatch(MERGE_POST_SOURCE, {
          //   key: keyPost,
          //   data: likeData,
          //   screenName
          // })
          const eventName = newLike ? 'chi_post_like' : 'chi_post_dislike'
          RegisterEvent(eventName, {
            target_id: keyPost,
            target_type: 'post_id'
          })
          resolve(newLike)
        })
    })
  },
  [MERGE_POST_SOURCE]: ({ commit, getters, dispatch }, value) => {
    const { key, data, screenName } = value
    const getterAsociated = {
      Homepage: MERGE_POST,
      Mixed: MERGE_AUTHOR,
      SinglePostFav: MERGE_SINGLE_POST,
      SinglePostNotif: MERGE_SINGLE_POST,
      SinglePostAuthor: MERGE_SINGLE_POST,
      Favs: MERGE_LIKE
    }
    const sourceInGetters = getterAsociated[screenName]
    sourceInGetters && dispatch(sourceInGetters, { key, data })
  },
  [RESET_LIKES_ACTION]: ({ commit }) => {
    commit(RESET_LIKES)
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/likesQuery.js